<script>
import isEmpty from "lodash/isEmpty";
import AutocompleteWithMap from "@/components/AutocompleteWithMap";
import Actions from "./Actions.vue";

export default {
    name: "AddVenue",
    components: {
        AutocompleteWithMap,
        Actions,
    },
    emits: ["stepChange"],
    data() {
        return {
            recurrenceType: "",
            venues: [],
            modalVenue: {
                idx: "",
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                country: "United Kingdom",
            },

            venuesErrors: [],

            existingVenues: [],

            currentStep: "address",
            showSummary: false,

            autocompleteError: "",
            existingVenueError: "",
        };
    },
    methods: {

        enterChanged(enterValue) {
            if (enterValue) {
                this.currentStep = "summary";
                this.showSummary = true;
                this.autocompleteError = "";
            } else {
                this.currentStep = "address";
                this.showSummary = false;
            }
        },

        addVenue(venue, fromMPSimpleAddVenueBool) {
            this.venues.push(venue);
            if (this.venues.length > 0) {
                this.submit(fromMPSimpleAddVenueBool);
            }
        },

        prevStep() {
            const comeFromMp = this.$storage.getStorageSync("fromMP");
            if (comeFromMp) {
                if (this.currentStep === "address") {
                    window.location.href = "/management-panel/simple";
                } else {
                    this.$refs.autocomplete.enterManually(); // on manual summary form , go back to map
                }
            } else if (this.$refs.autocomplete.manualAddress) {
                this.$refs.autocomplete.manualAddress = false;
                this.showSummary = false;
                this.currentStep = "address";
            } else {
                this.$router.push({ name: "Listing type" });
            }
        },
        passedThisValidation() {
            if (this.venues.length === 0 && !isEmpty(this.$refs.autocomplete.autocomplete) && this.currentStep === "address") {
                this.$refs.autocomplete.enterManually();
                this.$refs.autocomplete.validateForm(); // going from map page to summary page, we need to show the red errors to prompt user to enter stuff - lm LPPT-1755
                return false;
            }

            if (this.venues.length === 0 && this.currentStep === "summary") {
                this.$refs.autocomplete.saveVenue(true);
                return false;
            }

            if (this.venues.length === 0 && this.currentStep !== "summary") {
                this.autocompleteError = "Enter an address";
                this.existingVenueError = "Select a venue";
                return false;
            }

            if (this.venues.length > 0) {
                this.autocompleteError = "";
                this.existingVenueError = "";
            }

            if (this.autocompleteError !== "" || this.existingVenueError !== "") {
                return false;
            }

            return true;
        },
        async submit(fromMPSimpleAddVenueBool = false) {
            if (!this.passedThisValidation()) {
                return;
            }

            this.autocompleteError = "";

            this.$storage.setStorageSync("venues", this.venues);

            const fromMP = this.$storage.getStorageSync("fromMP") || false;

            if (fromMP && this.venues[0].venueId === undefined) {
                const venue = this.$storage.getStorageSync("venues");

                const formData = new FormData();

                formData.append("userId", window.currentUserId);
                formData.append("venue", JSON.stringify(venue[0]));

                const res = await fetch("/add-venue-for-simple-flow", {
                    method: "POST",
                    body: formData,
                });

                const data = await res.json();

                if (data.success) {
                    this.$storage.clearStorageSync();
                    window.onbeforeunload = null;
                    window.location.href = `/management-panel/simple/${data.data.venueId}`;
                } else {
                    alert("Form submitted with errors");
                }
            } else {
                const routeTo = { name: "Simple venues" };
                if (fromMPSimpleAddVenueBool === true) {
                    routeTo.query = { alreadySelectedVenueRedirectFiring: "true" };
                }
                this.$router.push(routeTo);
            }
        },

        getExistingVenues() {
            const formData = new FormData();

            formData.append("userId", window.currentUserId);

            fetch("/get-existing-locations", {
                method: "POST",
                body: formData,
            }).then((res) => res.json()).then((data) => {
                if (data.success) {
                    this.existingVenues = data.data;
                }
            });
        },
    },
    watch: {
        venueType() {

        },
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        const fromMP = params.get("fromMP");
        const fromAddVenueSimple = params.get("fromAddVenueSimple");

        if (fromMP !== null) {
            this.$storage.clearStorageSync();
            this.$storage.setStorageSync("fromMP", true);

            let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            if (fromAddVenueSimple === "yes") {
                newUrl += "?fromAddVenueSimple=yes";
            }

            window.history.replaceState({}, "title", newUrl);
        }

        const venues = this.$storage.getStorageSync("venues");
        this.venues = venues || [];

        const activityType = this.$storage.getStorageSync("activityType") || {};
        this.recurrenceType = activityType.flowType === "one-off" ? "" : activityType.recurrenceType || "";

        const venuesErrors = this.$storage.getStorageSync("rec-venues") || {};

        if (Object.keys(venuesErrors).length > 0) {
            let notificationText = "";
            // eslint-disable-next-line array-callback-return
            Object.keys(venuesErrors).map((error, idx) => {
                notificationText += `<em>venue</em> ${idx} <br>`;

                // eslint-disable-next-line array-callback-return
                Object.keys(venuesErrors[error]).map((nestedName) => {
                    notificationText += `<b>${nestedName}</b> : ${venuesErrors[error][nestedName]} <br>`;
                });
            });

            this.$notify({
                type: "warn",
                title: "<h6>Venues</h6>",
                text: notificationText,
            });
        }

        this.getExistingVenues();
    },
};
</script>

<template>
    <div class="d-flex flex-row add-venue-container">
        <div class="pages-menu position-absolute">
            <div class="venue-small-title">
                Add a venue
            </div>
            <div class="d-flex flex-row mt-2 ml-2">
                <div class="circle-icon">
                    <svg
                        v-if="currentStep === 'address'"
                        width="14"
                        height="37"
                        viewBox="0 0 14 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <line x1="7.25" y1="14" x2="7.25" y2="37" stroke="#999999" stroke-width="0.5"/>
                        <path
                            d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z"
                            fill="#FFB700"
                        />
                    </svg>

                    <svg
                        v-if="currentStep !== 'address'"
                        width="14"
                        height="40"
                        viewBox="0 0 14 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <line x1="7.25" y1="7" x2="7.25" y2="40" stroke="#999999" stroke-width="0.5"/>
                        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#999999"/>
                        <path
                            d="M13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7Z"
                            fill="white"
                            stroke="#FFB700"
                        />
                        <path d="M4.33398 7L6.33398 9.5L9.66732 4.5" stroke="#FFB700" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="mt-n1" :class="{'font-weight-600': currentStep === 'address'}">
                    Address
                </div>
            </div>

            <div class="d-flex flex-row ml-2">
                <div class="circle-icon">
                    <svg v-if="currentStep === 'summary'" width="14" height="37" viewBox="0 0 14 37" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z"
                            fill="#FFB700"
                        />
                    </svg>
                    <svg
                        v-if="currentStep !== 'summary'"
                        width="14"
                        height="37"
                        viewBox="0 0 14 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#999999"/>
                    </svg>
                </div>

                <div class="mt-n1" :class="{'font-weight-600': currentStep === 'summary'}">Summary</div>
            </div>
        </div>

        <div class="d-flex flex-column mx-auto">
            <div class="add-venue-block">
                <h2 v-if="showSummary">
                    Summary<br/><span class="title-sub-text">Confirm your venue’s details.</span>
                </h2>
                <h2 v-else>Address</h2>

                <AutocompleteWithMap
                    :venues="venues"
                    @venue-added="addVenue"
                    :hide-venues="true"
                    :existing-venues="existingVenues"
                    :show-enter-manually-button="true"
                    :show-confirm-button="false"
                    @enter-manually-changed="enterChanged"
                    ref="autocomplete"
                    :autocomplete-error="autocompleteError"
                    :existing-venue-error=existingVenueError
                    :show-summary-only="showSummary"
                />
            </div>
        </div>
    </div>

    <Actions
        @prev="prevStep"
        @next="submit"
        class="fixed-bottom"
        :disabled="false"
        :full-width="true"
        :next-button-text="showSummary ? 'Add venue' : 'Next'"
        actions-styles="alt-bottom-actions"
        additional-block-class="pages-menu"
    />
</template>

<style scoped>
.added-classes-container {
    top: 47px !important;
}

.circle-icon {
    margin-right: 8px;
}

.title-sub-text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #636066;
}

.font-weight-600 {
    font-weight: 600;
}

@media only screen and (max-width: 768px) {
    .pages-menu {
        position: relative !important;
    }

    .add-venue-container {
        flex-direction: column !important;
    }
}
</style>
